export default __webpack_public_path__ + "static/media/Scandic_50_x_50.7a05081e.jpg";